<template>
    <div class="boxbgcolor platform-merchant">
      <div class="tree">
        <area-tree :moduleName="moduleName" v-on:handleTreeClick='handleTreeClick' class="clique-tree"></area-tree>
        <merchant-tree  :groupId="treeData.groupId" class="merchant-tree" ref="merchantTree" v-on:merchantTreeCallback="merchantTreeCallback"></merchant-tree>
      </div>
      <merchant v-show="!merchantTreeData.id"  :groupId="treeData.groupId" ></merchant>
      <merchant-user v-show="treeData.groupId&&merchantTreeData.id" :merchant="merchantTreeData"></merchant-user>
    </div>
  </template>
  
  <script>

  import AreaTree from "../../../commons/areaTree.vue";
  import MerchantTree from "./components/MerchantTree/MerchantTree.vue"
  import Merchant from "./components/Merchant/Merchant.vue"
  import MerchantUser from "./components/MerchantUser/MerchantUser.vue"
 
  export default {
   
    data() {
      return {
        moduleName: "property",
        merchantVisible: false,
        treeData: {
          groupId: "",
          areaId: "",
        },
        merchantTreeData:{

        }
      };
    },
    components: {
      MerchantTree,
      AreaTree,
   
      Merchant,
      MerchantUser
    },
    methods: {
      //点击树的节点展示相应数据
        handleTreeClick: function (node, data) {
          this.treeData.groupId = node.id;
          this.merchantTreeData={}
        },
      merchantCallback() {
       this.$refs.merchantTree.getMerchantList();
      },
      merchantTreeCallback(node){
        
        this.merchantTreeData=node;
      },
    
      
    },
  };
  </script>
  
  <style scoped>
  .sameLine .el-form-item__content .el-input {
    display: inline-block;
    width: 70%;
  }
  .tip {
    color: red;
  }

  </style>
  <style lang="scss">
.platform-merchant .tree{
  display: flex;
  justify-content: flex-start;
}
</style>
  